<template>
    <div v-if="CookieBannerNotAccepted" ref="CookieBanner" class="uk-alert-large uk-alert-primary" uk-alert>
        <a class="uk-alert-close" uk-close v-on:click="CloseCookieBanner"></a>
        <p>{{this.settings.cookie_banner_text}} <a v-on:click="CloseCookieBanner">Accetto</a></p>
    </div>
</template>

<script>
import axios from "axios";
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { settings } from "@/settings";

let API_SERVER = settings.API_SERVER;

export default {
  name: 'CookieBannerView',
  data: function () {
    return {
      settings: {"cookie_banner_text":"",},
    }
  },
  methods: {
    CloseCookieBanner(){
      UIkit.alert(this.$refs.CookieBanner).close();
      this.$cookie.set("cookie_banner", "accept", { expires: '1Y' });
    },
    getSettings() {

        axios
          .get(API_SERVER + '/_/items/web_settings')
          .then(response => {
            if(response.data.data.length >0){
              console.log(response.data.data[0]);
              this.settings = response.data.data[0];
              console.log(this.settings.cookie_banner_text);
            }
        });

    },
  },
  computed: {
    CookieBannerNotAccepted(){
      let c = this.$cookie.get("cookie_banner");
      if(c == "accept"){
        return false;
      }
      return true;
    }
  },
  created() {
      this.getSettings();
  }
}
</script>